<router-outlet></router-outlet>
<app-consent-banner></app-consent-banner>